// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__Kfvy9","pageNumber":"style_pageNumber__CrM18","pageActive":"style_pageActive__Hi2+L"};